import React from 'react';
import '../assets/license.css'
import '../assets/app.css'
import '../App.css'
import Header from './Header'
import AppCache from '../modules/AppCache'
import Footer from './Footer'
import DiscountApi from '../api/discount'
import constants from '../constants/constants'

export default class LicensePromotion extends React.Component {
	license = [
		{ priceText: '1 Year', price: '99.95', buyNowKey: '2' },
		{ priceText: '2 Years', price: '149.95', buyNowKey: '3' },
	];

	constructor(props) {
		super(props)
		const result = AppCache.getRedeemData();
		this.localhostName = window.location.origin;
		const query = new URLSearchParams(window.location.search);
		this.state = {
			selectedLicenseType: 0,
			discountCouponNumber: '',
			applyDiscount: false,
			discountCode: '',
			sWBtnValue: 2,
			ONE_YEAR_DISCOUNT_PREFIX: "DF",
			TWO_YEAR_DISCOUNT_PREFIX: "DS",
			writerType: query.get('writer_type'),
			dcn: query.get('dcn'),
			oneYearDiscountAmt: 0.00,
			twoYearDiscountAmt: 0.00,
		};
	}

	async componentDidMount() {
		const query = new URLSearchParams(window.location.search);
		document.title =  (query.get('writer_type') == 1) ? 'Pricing | MasterWriter for Creative Writing' : 'Pricing | MasterWriter for Songwriting';
		const discountCouponNumber = query.get('dcn');
		if (discountCouponNumber) {
			this.discountCalculation(discountCouponNumber, this.license)
		}
	}

	async discountCalculation(discountCouponNumber) {
		const { ONE_YEAR_DISCOUNT_PREFIX, TWO_YEAR_DISCOUNT_PREFIX } = this.state;
		let [oneYearDiscountAmt, twoYearDiscountAmt] = Array(2).fill(0);
		if (discountCouponNumber.includes("DF"))
			var oneYearDiscountCode = discountCouponNumber
		else
			var oneYearDiscountCode = ONE_YEAR_DISCOUNT_PREFIX + discountCouponNumber;
		if (discountCouponNumber.includes("DS"))
			var twoYearDiscountCode = discountCouponNumber
		else
			var twoYearDiscountCode = TWO_YEAR_DISCOUNT_PREFIX + discountCouponNumber;
		let discountFetch = {
			oneYearDiscountCode: oneYearDiscountCode,
			twoYearDiscountCode: twoYearDiscountCode,
		}
		let discountAmt = await DiscountApi.findDiscountByDiscountCode(discountFetch)
		discountAmt.map(item => {
			if (item.code.includes("DF")) {
				oneYearDiscountAmt = item.value;
			} else if (item.code.includes("DS")) {
				twoYearDiscountAmt = item.value;
			}
		})
		this.setState({ oneYearDiscountAmt, twoYearDiscountAmt })
	}

	selectLicense = (e) => {
		const { sWBtnValue, writerType } = this.state;
		e.preventDefault();
		let URL;
		const type = e.currentTarget.dataset.value;
		if (writerType != null) {
			if (type == 2) {
				if (writerType == sWBtnValue) {
					URL = this.getTargetURL(constants.MW3OneYearSWlicenseOrder, 2);
				} else {
					URL = this.getTargetURL(constants.MW3OneYearCWlicenseOrder, 1);
				}
				window.location = URL;
			} else if (type == 3) {
				if (writerType == sWBtnValue) {
					URL = this.getTargetURL(constants.MW3TwoYearSWlicenseOrder, 2);
				} else {
					URL = this.getTargetURL(constants.MW3TwoYearCWlicenseOrder, 1);
				}
				window.location = URL;
			} else {
				alert("Please select License Option");
			}
		} else {
			alert("Please select Writer Type");
		}
	}

	getTargetURL = (requestURL, writerType) => {
		const { dcn } = this.state;
		let discountCode = dcn;
		if (!discountCode) {
			discountCode = "";
		} else {
			discountCode = "&dcn=" + discountCode;
		}
		var writerTypeParam = "&writer_type=" + writerType
		return this.localhostName + requestURL + "serialNumber=0"
			+ discountCode + writerTypeParam;
	}

	getDiscount = (price, discount) => {
		return parseFloat(price - discount).toFixed(2);
	}

	getPerMonthValue = (price, discount) => {
		return (parseFloat(price - discount) / 12).toFixed(2);
	}

	getPerTwoYearValue = (price, discount) => {
		return (parseFloat(price - discount) / 24).toFixed(2);
	}

	render() {
		const { oneYearDiscountAmt, twoYearDiscountAmt, writerType } = this.state
		return (
			<>
				<Header />
				<div id="sliders-container"></div>
				<main id="content" className="site-main post-15187 page type-page status-publish hentry">
					<div className="page-content">
						<div data-elementor-type="wp-page" data-elementor-id="15187" className="elementor elementor-15187"
							data-elementor-post-type="page">
							<section
								className="elementor-section elementor-top-section elementor-element elementor-element-2ff083a2 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
								data-id="2ff083a2" data-element_type="section"
								data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
								<div className="elementor-container elementor-column-gap-default">
									<div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-73da5b2a"
										data-id="73da5b2a" data-element_type="column"
										data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
										<div className="elementor-widget-wrap elementor-element-populated">
											<div className="elementor-element elementor-element-56531d19 elementor-widget elementor-widget-heading"
												data-id="56531d19" data-element_type="widget" data-widget_type="heading.default">
												<div className="elementor-widget-container">

													<h1 className="elementor-heading-title elementor-size-default">Select a License</h1>
												</div>
											</div>
										</div>
									</div>
								</div>
							</section>
							<section
								className="elementor-section elementor-top-section elementor-element elementor-element-1fcb4dc9 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
								data-id="1fcb4dc9" data-element_type="section">
								<div className="elementor-container elementor-2-box elementor-column-gap-default">
									<div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-563b1cfa"
										data-id="563b1cfa" data-element_type="column">
										<div className="elementor-widget-wrap elementor-element-populated">
											<section
												className="elementor-section elementor-2-box-section elementor-inner-section elementor-element elementor-element-7eb3fd3d elementor-section-boxed elementor-section-height-default elementor-section-height-default"
												data-id="7eb3fd3d" data-element_type="section"
												data-settings="{&quot;background_background&quot;:&quot;classic&quot;}"
												data-e-bg-lazyload="">
												<div className="elementor-container elementor-column-gap-default">
													{this.license && this.license.map((license, index) => (
														<React.Fragment key={license.buyNowKey || index}>
															<div className="elementor-column elementor-col-33 elementor-mobile-2-box elementor-inner-column elementor-element elementor-element-62178c42"
																data-id="4707ddb5" data-element_type="column" style={{width: '50%'}}>
																<div className="elementor-widget-wrap elementor-element-populated">
																	<section
																		className="elementor-section elementor-inner-section elementor-element elementor-element-287fdec3 license-card elementor-section-height-default elementor-section-height-default licence-promotion-2-box"
																		data-id="287fdec3" data-element_type="section"
																		data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
																		<div className="elementor-container elementor-column-gap-default">
																			<div className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-4d4485f7"
																				data-id="4d4485f7" data-element_type="column">
																				<div
																					className="elementor-widget-wrap elementor-element-populated">
																					<div className="elementor-element elementor-element-7de60c95 elementor-widget elementor-widget-heading"
																						data-id="7de60c95" data-element_type="widget"
																						data-widget_type="heading.default">
																						<div className="elementor-widget-container">
																							<h4
																								className="elementor-heading-title elementor-size-default">
																								{license.priceText} </h4>
																						</div>
																					</div>
																					<div className="elementor-element elementor-element-a475af1 elementor-widget elementor-widget-html"
																						data-id="a475af1" data-element_type="widget"
																						data-widget_type="html.default">
																						<div className="elementor-widget-container">
																							<div className="reg-price-container">
																								<div className="divider">
																									<div className="red-line"></div>
																								</div>
																								<div className="price">${license.price}</div>
																							</div>
																						</div>
																					</div>
																					<div className="elementor-element elementor-element-7605e2c0 elementor-widget elementor-widget-text-editor"
																						data-id="7605e2c0" data-element_type="widget"
																						data-widget_type="text-editor.default">
																						<div className="elementor-widget-container"> NOW ONLY<br
																							className="" /><span
																								className="card-pricing">${license.price === '99.95' ? this.getDiscount(license.price, oneYearDiscountAmt) : this.getDiscount(license.price, twoYearDiscountAmt)}</span> <br
																								className="" />{license.price == '9.95' ? <span style={{ fontSize: '16px' }}></span> : ((license.price == '99.95' ? <span>(breaks down to<br className=""/>${this.getPerMonthValue(license.price, oneYearDiscountAmt) + '/month)'}</span> : 
																								<span>(breaks down to<br className=""/>${this.getPerTwoYearValue(license.price, twoYearDiscountAmt) + '/month)'}</span>))}</div>
																					</div>
																					<div className="elementor-element elementor-element-35069d61 elementor-widget elementor-widget-html"
																						data-id="35069d61" data-element_type="widget"
																						data-widget_type="html.default">
																						<div className="elementor-widget-container">
																							<div className="icons-container">
																								<ul className="icons-list">
																									<li>Free Updates</li>
																									<li>Free Upgrades</li>
																									<li>Free Support</li>
																								</ul>
																							</div>
																						</div>
																					</div>
																					<div className="elementor-element elementor-element-66d7a040 licenseBtn elementor-widget elementor-widget-text-editor"
																						data-id="66d7a040" data-element_type="widget"
																						data-widget_type="text-editor.default">
																						<div className="elementor-widget-container">
																							<ul>
																								<li><a className="licenseBtn"
																									data-value={license.buyNowKey} href='' type="submit" onClick={this.selectLicense}>Buy Now</a></li>
																							</ul>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																	</section>
																</div>
															</div>
														</React.Fragment>
													))}
												</div>
											</section>
										</div>
									</div>
								</div>
							</section>
							<section
								className="elementor-section elementor-top-section elementor-element elementor-element-2e9d508a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
								data-id="2e9d508a" data-element_type="section">
								<div className="elementor-container elementor-column-gap-default">
									<div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2967eef6"
										data-id="2967eef6" data-element_type="column">
										<div className="elementor-widget-wrap elementor-element-populated">
											<div className="elementor-element elementor-element-5d0618d9 elementor-widget elementor-widget-text-editor"
												data-id="5d0618d9" data-element_type="widget"
												data-widget_type="text-editor.default">
												<div className="elementor-widget-container"> IF YOU HAVE ANY QUESTIONS CONTACT US AT:
													1-866-848-8484 OR EMAIL <a className="in-text-link"
														href="mailto:support@masterwriter.com">SUPPORT@MASTERWRITER.COM</a> </div>
											</div>
										</div>
									</div>
								</div>
							</section>
							<section
								className="elementor-section elementor-top-section elementor-element elementor-element-53b8361c elementor-section-boxed elementor-section-height-default elementor-section-height-default"
								data-id="53b8361c" data-element_type="section">
								<div className="elementor-container elementor-column-gap-default">
									<div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-1a719799 elementor-hidden-mobile"
										data-id="1a719799" data-element_type="column">
										<div className="elementor-widget-wrap"> </div>
									</div>
									<div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-50a572cf"
										data-id="50a572cf" data-element_type="column">
										<div className="elementor-widget-wrap elementor-element-populated">
											<section
												className="elementor-section elementor-inner-section elementor-element elementor-element-207c9650 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
												data-id="207c9650" data-element_type="section">
												<div className="elementor-container elementor-column-gap-default">
													<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-3e35c996"
														data-id="3e35c996" data-element_type="column">
														<div className="elementor-widget-wrap elementor-element-populated">
															<div className="elementor-element elementor-element-4eed119f elementor-widget elementor-widget-image"
																data-id="4eed119f" data-element_type="widget"
																data-widget_type="image.default">
																<div className="elementor-widget-container"> <img decoding="async"
																	width="291" height="291"
																	src="./store/images/2022-10-guarantee_badge.png"
																	className="attachment-large size-large wp-image-9996" alt=""
																	loading="lazy"
																	srcSet="./images/2022-10-guarantee_badge.png 291w, ./images/2022-10-guarantee_badge-150x150.png 150w"
																	sizes="(max-width: 291px) 100vw, 291px" /> </div>
															</div>
														</div>
													</div>
													<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-20055aea"
														data-id="20055aea" data-element_type="column">
														<div className="elementor-widget-wrap elementor-element-populated">
															<div className="elementor-element elementor-element-4c236575 elementor-widget elementor-widget-text-editor"
																data-id="4c236575" data-element_type="widget"
																data-widget_type="text-editor.default">
																<div className="elementor-widget-container"> If you aren’t 100%
																	satisfied with your purchase of MasterWriter, let us know within
																	90 days and we’ll give you your money back. Our mission is to
																	make you a better {writerType === '1' ? 'writer' : 'songwriter'}. We’re confident MasterWriter will
																	help. But if it doesn’t, then you shouldn’t be charged for it.
																	Simple as that! </div>
															</div>
														</div>
													</div>
												</div>
											</section>
										</div>
									</div>
									<div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-1143ca42 elementor-hidden-tablet elementor-hidden-mobile"
										data-id="1143ca42" data-element_type="column">
										<div className="elementor-widget-wrap"> </div>
									</div>
								</div>
							</section>
							<section
								className="elementor-section elementor-top-section elementor-element elementor-element-1b428020 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
								data-id="1b428020" data-element_type="section">
								<div className="elementor-container elementor-column-gap-default">
									<div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-fea1a61"
										data-id="fea1a61" data-element_type="column">
										<div className="elementor-widget-wrap elementor-element-populated">
											<div className="elementor-element elementor-element-6a82c34b elementor-widget elementor-widget-spacer"
												data-id="6a82c34b" data-element_type="widget" data-widget_type="spacer.default">
												<div className="elementor-widget-container">

													<div className="elementor-spacer">
														<div className="elementor-spacer-inner"></div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</section>
						</div>
						<div className="post-tags"> </div>
					</div>
				</main>
				<Footer />
			</>
		)
	}


}
